import config from "../../../../config";
import { ResponseDto } from '../../../../dtos/common/responseDto';
import { deleteData, getData, patchData, postData } from '../../../../utils/axios/serverHelper';
import { formatDate } from '../../../../utils/string/stringUtil';
import axios from 'axios';

import { KSK2021_R01LotDto, KSK2021_R01Dto, KSK2021_R01HeaderDto, KSK2021_R01InspectDto, KSK2021_R01ProductResultDto, KSK2021_R01DetailDto, KSK2021_R01LotSearchDto } from './Dto_KSK2021_R01';
import { KSK2021_R01Filter } from "./Store_KSK2021_R01";

const baseUrl = `${config.apiUrl}/KSK2021_R01`;

const getParams = (filter: Partial<KSK2021_R01Filter>, listLength?: number) => {	
	return {
		labelPrintAuto: filter.labelPrintAuto || undefined,

		listLength: listLength || 0
	}
}

export const getKSK2021_R01List = async (option: string, params: Partial<KSK2021_R01Filter>, listLength: number = 0) => {

	const url = `${baseUrl}/${option}`;

	return await getData<ResponseDto<KSK2021_R01HeaderDto[]>>(url, { params: getParams(params, listLength) });
}

export const getKSK2021_R01AllCount = async (params: Partial<KSK2021_R01Filter>) => {
    const url = `${baseUrl}/allCount`;

    return await getData<ResponseDto<number>>(url, {
        params: getParams(params, 0)
    });
}

export const getKSK2021_R01One = async (productOrderNo: string) => {
	const url = `${baseUrl}/one/${productOrderNo}`;
	return await getData<ResponseDto<KSK2021_R01HeaderDto>>(url);
}

export const getKSK2021_R01ProductResultList = async (productOrderNo: string, productWorkNo: string) => {
	const url = `${baseUrl}/productResult/${productOrderNo}/${productWorkNo}`;
	return await getData<ResponseDto<KSK2021_R01ProductResultDto>>(url);
}

export const getKSK2021_R01LotList = async (itemCd: string) => {
	const url = `${baseUrl}/lot/${itemCd}`;

	return await getData<ResponseDto<KSK2021_R01LotDto[]>>(url);
}

export const getKSK2021_R01LotSearch = async (data: KSK2021_R01LotSearchDto) => {
	const url = `${baseUrl}/lot/modal`;

	return await getData<ResponseDto<KSK2021_R01LotSearchDto>>(url, { params: data });
}

export const createKSK2021_R01LotNo = async () => {
	const url = `${baseUrl}/lot/createLotNo`;
	return await getData<ResponseDto<string>>(url);
}

// pic 전용 상세내역 조회 api
export const getKSK2021_R01DetailList = async (productWorkNo: string, itemCd: string, productQty: number, badQty: number, outWarehouseCd: string, logicCenter: string, workplaceCd: string) => {
	const url = `${baseUrl}/detail`;

	return await getData<ResponseDto<KSK2021_R01DetailDto[]>>(url, { params: { 
			basOrderNo: productWorkNo,
			itemCd: itemCd,
			productQty: productQty,
			badQty: badQty,
			outWarehouseCd: outWarehouseCd,
			logicCenter: logicCenter,
			workplaceCd: workplaceCd,
		} 
	});
}

// PIC 전용 자재 탐색 api
export const getKSK2021_R01DetailStockList = async (productWorkNo: string, itemCd: string, outWarehouseCd: string, logicCenter: string) => {
	const url = `${baseUrl}/detail/stock`;

	return await getData<ResponseDto<KSK2021_R01DetailDto[]>>(url, { params: { 
			basOrderNo: productWorkNo,
			itemCd: itemCd,
			outWarehouseCd: outWarehouseCd,
			logicCenter: logicCenter
		} 
	});
}

export const getKSK2021_R01TransportedInfo = async (productResultNo: string) => {
	const url = `${baseUrl}/detail/transported`;
	return await getData<ResponseDto<KSK2021_R01DetailDto[]>>(url, {
		params: {
			productResultNo: productResultNo
		}
	});
}

export const getKSK2021_R01InspectList = async (productResultNo: string) => {
	const url = `${baseUrl}/inspect/${productResultNo}`;

	return await getData<ResponseDto<KSK2021_R01InspectDto[]>>(url);
}

// export const getKSK2021_R01DowntimeList = async (productResultNo: string) => {
// 	const url = `${baseUrl}/downtime/${productResultNo}`;

// 	return await getData<ResponseDto<KSK2021_R01DowntimeDto[]>>(url);
// }

export const postKSK2021_R01 = async (data: KSK2021_R01Dto) => {

	const url = `${baseUrl}`;

	return await postData<KSK2021_R01Dto, ResponseDto<KSK2021_R01Dto>>(url, data);
}

export const patchKSK2021_R01 = async (data: KSK2021_R01Dto) => {

	const url = `${baseUrl}`;

	return await patchData<KSK2021_R01Dto, ResponseDto<KSK2021_R01Dto>>(url, data);
}

export const patchKSK2021_R01WorkStart = async (productWorkNo: string, timeParam: string) => {
	const url = `${baseUrl}/workStart`;
	const data = { productWorkNo: productWorkNo, timeParam: timeParam } as KSK2021_R01HeaderDto;
	return await patchData<KSK2021_R01HeaderDto, ResponseDto<KSK2021_R01HeaderDto>>(url, data);
}

export const patchKSK2021_R01WorkEnd = async (productWorkNo: string, timeParam: string) => {
	const url = `${baseUrl}/workEnd`;
	const data = { productWorkNo: productWorkNo, timeParam: timeParam } as KSK2021_R01HeaderDto;
	return await patchData<KSK2021_R01HeaderDto, ResponseDto<KSK2021_R01HeaderDto>>(url, data);
}

export const deleteKSK2021_R01 = async (purchaseBillNo: string) => {

	const url = `${baseUrl}`;

	return await deleteData<ResponseDto<any>>(url, {
		params: {
			purchaseBillNo
		}
	});
}

export const downloadExcel_KSK2021_R01 = async (option: string, purchaseBillNo: string, listLength: number = 0) => {
	const url = `${baseUrl}/excel/${option}`

	return await getData<ResponseDto<string>>(url, {
		params: {
			purchaseBillNo
		}
	})
}
export const printKSK2021_R01 = async (purchaseBillNo: string) => {
	const url = `${baseUrl}/print`;
	const response = await getData<Blob>(url, {
	  params: { purchaseBillNo },
	  responseType: "blob",
	});
	const fileBlob = new Blob([response.data], { type: "application/pdf" });
	const fileURL = URL.createObjectURL(fileBlob);
	window.open(fileURL, "_blank");
  };
